import React from 'react';
import { SlidePage } from '../index';
import { BodyContainer, ProgressBox, ProgressStat } from '../styles';
import { dimColors } from '../constants';

// const getColor = value => {
//   if (value < 40) {
//     return polarColors[0];
//   }
//   return polarColors[4];
// };

const DecisionMakingFirstPage = ({ user, background, number }) => {
  // const { TOP_DECISION_STYLE } = user;
  const afrontamientoProductivo = parseFloat(user['Afrontamiento Productivo']);

  return (
    <SlidePage number={number} background={background}>
      <BodyContainer>
        <div className='content'>
          <h2>3.4. Estilo personal de toma de decisión</h2>
          <p className='justified'>
            Las personas pueden afrontar las dificultades asociadas al proceso
            de toma de decisión sobre su carrera a futuro de distintas formas,
            siendo algunas formas más beneficiosas para el proceso de elegir una
            carrera profesional. <br /> <br />
            Tu estilo predominante de decisión es aquel en el que tienes{' '}
            <strong>mayor puntaje</strong>.
          </p>
          <h3>Afrontamiento Productivo</h3>
          <p className='justified'>
            Aquellos que muestran puntajes altos en esta escala tienden a
            emplear{' '}
            <strong>
              estrategias que apoyan un afrontamiento efectivo y positivo en el
              proceso de elección de carrera
            </strong>
            . Este tipo de estrategias, que incluyen la búsqueda activa de
            información sobre posibles carreras, la planificación y análisis
            sistemático de la información disponible, la comparación de
            alternativas y la disposición para equilibrar distintas preferencias
            e intereses que pueden entrar en conflicto, resultan ser muy
            beneficiosas. Además, mantener una actitud positiva frente al
            desafío de la elección de carrera puede ser un factor de motivación
            adicional.
          </p>
          <p className='justified'>
            Por ejemplo, se puede investigar en línea, asistir a ferias de
            carreras, o solicitar citas con orientadores de carrera para obtener
            una mayor cantidad de información. También se utilizan estrategias
            como organizar información en hojas de cálculo o listas para
            comparar sus opciones, teniendo en cuenta factores como las
            habilidades requeridas, los posibles resultados de la carrera, la
            ubicación de las universidades, entre otros.
          </p>
          <div className='paragraph'>
            ¿Cómo potenciar y trabajar este estilo?
          </div>
          <ul className='text-list'>
            <li>- Establecer metas a corto y largo plazo.</li>
            <li>- Construir una bitácora vocacional.</li>
            <li>- Investigar activamente sobre las carreras de interés.</li>
          </ul>
          <div className='progress-info-group'>
            <div className='progress-info'>
              <div className='progress-details-single'>
                <div className='progress-name'>Afrontamiento Productivo</div>
                <ProgressBox
                  progress={afrontamientoProductivo}
                  backColor={() => dimColors[2]}
                >
                  <div className='progress'></div>
                </ProgressBox>
                <ProgressStat>{afrontamientoProductivo}</ProgressStat>
              </div>
            </div>
          </div>
          <br />
        </div>
      </BodyContainer>
    </SlidePage>
  );
};

export default DecisionMakingFirstPage;
